export default {"src":"/vendor/_next/static/media/logo_small_white_new.b343b5e9.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};